import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import ScratchCard from './ScratchCard';
import WheelOfFortune from './WheelOfFortune';
import '../styles/valentine.css';

const ValentineLanding = () => {
  const [noButtonPosition, setNoButtonPosition] = useState({ x: 0, y: 0 });
  const [showActivities, setShowActivities] = useState(false);
  const [yesClicked, setYesClicked] = useState(false);

  const romanticActivities = [
    {
      id: 'florence',
      title: 'Firenze',
      image: 'firenze.webp',
      text: 'Andiamo a Firenze!'
    },    
    {
      id: 'workshop',
      title: 'Workshop di Profumeria',
      image: 'Antica-Erboristeria-San-Simone-Spezie.webp',
      text: 'Diventa apprendista Profumiere e crea il tuo profumo personalizzato'
    },
    {
      id: 'photo-booth',
      title: 'Fotoricordo',
      image: 'foto-automatica.webp',
      text: 'Foto nostalgiche da Fotoautomatica di Firenze.'
    },
    {
      id: 'lunch',
      title: 'Trattoria Zaza',
      image: 'trattoria-zaza.webp',
      text: 'La cucina toscana di un locale storico.'
    },
    {
      id: 'tiramisu',
      title: 'Dessert time',
      image: 'pompi-tiramisu.webp',
      text: 'Pompi, il regno del tiramisù e Chinatown di Firenze.'
    },    
    {
      id: 'museum',
      title: 'Inside Van Gogh',
      image: 'van-gogh.webp',
      text: 'Un affascinante racconto digitale di 35 minuti, con una multiproiezione a 360° e una coinvolgente colonna sonora.'
    },
    {
      id: 'sunset-walk',
      title: 'Piazzale Michelangelo',
      image: 'tramonti-firenze_q6G.webp',
      text: 'Il magnifico Belvedere su Firenze al tramonto.'
    },
    {
      id: 'photoshoot',
      title: 'Photoshoot',
      image: 'fotoshoot.webp',
      text: 'Photoshoot by Oru — spots from 小红书.'
    }

  ];

  const moveNoButton = () => {
    const maxX = window.innerWidth - 150;
    const maxY = window.innerHeight - 100;
    
    const newX = Math.random() * maxX;
    const newY = Math.random() * maxY;
    
    setNoButtonPosition({ x: newX, y: newY });
  };

  const handleYesClick = () => {
    setYesClicked(true);
    setTimeout(() => {
      setShowActivities(true);
    }, 300);
  };

  return (
    <div className="valentine-container">
      {/* Animated hearts background */}
      <div className="hearts-background">
        <div className="bubble bubble-1">
          <svg className="heart" viewBox="0 0 32 32">
            <path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"></path>
          </svg>
        </div>
        <div className="bubble bubble-2">
          <svg className="heart" viewBox="0 0 32 32">
            <path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"></path>
          </svg>
        </div>
        <div className="bubble bubble-3">
          <svg className="heart" viewBox="0 0 32 32">
            <path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"></path>
          </svg>
        </div>
        <div className="bubble bubble-4">
          <svg className="heart" viewBox="0 0 32 32">
            <path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"></path>
          </svg>
        </div>
        <div className="bubble bubble-5">
          <svg className="heart" viewBox="0 0 32 32">
            <path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"></path>
          </svg>
        </div>
      </div>

      {/* Main content */}
      <div className="valentine-content">
        {/* Heart decoration */}
        <div className="heart-decoration">
          <Heart className="heart-icon floating" fill="#ff6b9d" color="#ff6b9d" size={48} />
        </div>

        {/* Main question */}
        <h1 className="valentine-question">
          Will you be my Valentine?
        </h1>

        {/* Buttons container */}
        {!yesClicked && (
          <div className="buttons-container">
            <button
              className="yes-button"
              onClick={handleYesClick}
            >
              <Heart className="button-heart" fill="white" color="white" size={20} />
              Yes
            </button>

            <button
              className="no-button"
              onMouseEnter={moveNoButton}
              onTouchStart={moveNoButton}
              style={{
                position: noButtonPosition.x !== 0 ? 'fixed' : 'relative',
                left: noButtonPosition.x !== 0 ? `${noButtonPosition.x}px` : 'auto',
                top: noButtonPosition.y !== 0 ? `${noButtonPosition.y}px` : 'auto',
                transition: 'all 0.3s ease'
              }}
            >
              No
            </button>
          </div>
        )}

        {/* Success message after clicking Yes */}
        {yesClicked && !showActivities && (
          <div className="success-message">
            <Heart className="success-heart" fill="#ff6b9d" color="#ff6b9d" size={64} />
            <p className="success-text">Yay! 💕</p>
          </div>
        )}

        {/* Activities section */}
        {showActivities && (
          <div className="activities-section">
            <div className="activities-header">
              <h2 className="activities-title">Valentine's Day Plans</h2>
              <p className="activities-subtitle">Cosa andremo a fare...</p>
            </div>

            <div className="activities-list">
              {romanticActivities.map((activity, index) => (
                <div
                  key={activity.id}
                  className="activity-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <ScratchCard image={`${process.env.PUBLIC_URL}/images/${activity.image}`}>
                    <div className="activity-content">
                      <p className="activity-title">{activity.title}</p>
                      <div className="activity-details">
                        <span className="activity-icon">{activity.icon}</span>
                        <p className="activity-text">{activity.text}</p>
                      </div>
                    </div>
                  </ScratchCard>
                </div>
              ))}
            </div>

            <div className="closing-message">
              <p className="closing-text">
                ...poi si torna a casuccia...
              </p>
            </div>

            {/* Wheel of Fortune */}
            <WheelOfFortune />
          </div>
        )}
      </div>
    </div>
  );
};

export default ValentineLanding;
